import { AccessorsMutatorsDecorator, Model } from "../../helpers";

/**
 * @class PropertyChannelDistribution
 *
 * @property {number} id
 */
export class PropertyChannelDistribution extends Model {


}

AccessorsMutatorsDecorator('id', 'property_id', 'is_active')(PropertyChannelDistribution);



// WEBPACK FOOTER //
// ./src/pms-api/models/property-channel-distribution.model.js